import getCharts from '../getCharts'
import { GetPatientDiagnosis } from '../../constants/api.config'

export default async function GetPatientDiagnosisDetails(patientID) {
  try {
    const payload = {patientID}
    const res = await getCharts(GetPatientDiagnosis, payload)
    return res.data
  } catch (error) {
    return error
  }
}
